import { setMetadata } from "../metadata/Metadata";
export function Bind(eventName, selector) {
    return function (target, propertyKey, descriptor) {
        setMetadata(target, 'EventListener', {
            eventName: eventName,
            selector: selector,
            handler: propertyKey
        }, propertyKey);
    };
}
//# sourceMappingURL=Bind.js.map


//////////////////
// WEBPACK FOOTER
// ../~/xm-ui/decorators/Bind.js
// module id = 41
// module chunks = 1